import { generatePath } from 'react-router-dom'

export enum AppRoute {
  Root = '/',
}

export const getRootRoute = () => generatePath(AppRoute.Root)
